import { Box } from "@mui/material";
import style from './FingerprintScanBtn.module.css'

export default function FingerprintScanBtn({
    onClick,
}: { onClick: () => void }) {
    return (<>
        <Box className={`${style.fingerprintScanBtn} fingerprint-scan-btn`}>
            <img
                onClick={onClick}
                src="/assets/finger_print_4.png"
                // src="/assets/image_fingerprint.svg"
                alt="Start Scam Identification"
                className={style.fingerprintImage}
                style={{
                    width: '130px',
                    height: '183px',
                    borderRadius: '45% 52% 43% 43% / 53% 54% 44% 46%'
                }}
            />
        </Box>
    </>
    );
}
